module.exports = __webpack_public_path__ + "img/SOKAL-WEB-112822-CreativeAnalysis-GMC-Established.7f1cda2f.jpeg";